// extracted by mini-css-extract-plugin
module.exports = {"root":"empty_root__3VHKY","image":"empty_image__bwdJS","title":"empty_title__26mJe","content":"empty_content__2XCmx"};